import {CMSContentType} from "../../CMSType";
import {RichTextContentMapper} from "./rich-text";
import {AContent, AContentDTO} from "../../base.content";
import {List} from 'immutable';
import {cmsStringToType, TYPE_DETAILS_CONTENT} from "../../constants";
import {DetailsContent, DetailsDTO, DetailsItemsDTO, DetailsParams} from "../details.content";
import {MapContentMapper} from "./map";
import {IContentMapper} from "../base.content";
import {GalleryMapper} from "./gallery";

export const DETAILS_CMS_TYPES: CMSContentType[] = [CMSContentType.richText, CMSContentType.map, CMSContentType.gallery];

export function detailsMapperFactory(type: CMSContentType): IContentMapper {
  switch (type) {
    case CMSContentType.richText:
      return new RichTextContentMapper();
    case CMSContentType.map:
      return new MapContentMapper();
    case CMSContentType.gallery:
      return new GalleryMapper();
    default:
      throw new Error('undefined type for details ' + type)
  }
}

export function parseDetails(dtos: DetailsItemsDTO[]): DetailsParams {
  return dtos.map((dto) => {
    let mapper = detailsMapperFactory(cmsStringToType(dto.type));
    return mapper.fromDTO(dto);
  }) as DetailsParams;
}

export function formatDetails(data: DetailsContent): DetailsItemsDTO[] {
  return data.items.toArray().map(item => {
    let mapper = detailsMapperFactory(item.type);
    return mapper.toDTO(item) as DetailsItemsDTO;
  });
}

export function isDetailsContent(list: AContentDTO[]): boolean {
  return list.reduce((previousValue, item) => previousValue && DETAILS_CMS_TYPES.indexOf(cmsStringToType(item.type)) !== -1, true);
}

export class DetailsContentMapper implements IContentMapper {
  toDTO(data: DetailsContent): DetailsDTO {
    return {
      type: TYPE_DETAILS_CONTENT,
      items: formatDetails(data)
    };
  }

  fromDTO(data: DetailsDTO): DetailsContent {
    return new DetailsContent(parseDetails(data.items));
  }
}



// WEBPACK FOOTER //
// ./src/api/club-cms/content/mappers/details.ts